module.exports = __webpack_public_path__ + "img/about-ch2-urbanproblems-naturaldisasters.ad0d7276.svg";